(function () {
  'use strict';

  function apiFactory ($resource, $httpParamSerializer) {
    function transformUrlEncoded (data) {
      return $httpParamSerializer(data);
    }

    function getHolidays () {
      return $resource(web2print.env.pricingBaseUrl + 'holidays', {
        'country': '@country',
        'language': '@language',
        'year': '@year'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function getProducts () {
      return $resource(web2print.env.pricingBaseUrl + 'getProducts', {
        'country': '@country',
        'language': '@language',
        'productId': '@productId',
        'modifyProduct': '@modifyProduct',
        'userType': '@userType',
        'recipientsCount': '@recipientsCount',
        'deliveryDate': '@deliveryDate'
      }, {
        'get': {
          'method': 'GET'
        },
        'post': {
          'method': 'POST'
        }
      });
    }

    function getPaymentMethods () {
      return $resource(web2print.env.ordersBaseUrl + 'paymentmethods/:country', {
        'country': '@country'
      });
    }

    function calculatePrice () {
      return $resource(web2print.env.pricingBaseUrl + '/calculatePrice', {
        'productId': '@productId',
        'deliveryId': '@deliveryId',
        'numberOfRecipients': '@numberOfRecipients',
        'numberOfExtraPages': '@numberOfExtraPages',
        'addressType': '@addresstype'
      }, {
        'post': {
          'method': 'POST',
          'isArray': true
        }
      });
    }

    function fetchProductTerms () {
      return $resource(web2print.env.pricingBaseUrl + 'productTerms/:objectId', {
        'objectId': '@objectId',
        'userType': '@userType',
      }, {
        'get': {
          'method': 'get'
        }
      });
    }

    function getOrders () {
      return $resource(web2print.env.ordersBaseUrl + 'orders', {
        'filterKey': '@filterKey',
        'filterValue': '@filterValue',
        'filterExclude': '@filterExclude'
      }, {
        'get': {
          'method': 'GET',
        }
      });
    }

    function getOrderById () {
      return $resource(web2print.env.ordersBaseUrl + 'orders/:orderId', {
        'orderId': '@orderId'
      }, {
        'get': {
          'method': 'GET'
        }
      });
    }

    function cancelOrder () {
      return $resource(web2print.env.ordersBaseUrl + 'cancelOrder', {
        'orderId': '@orderId'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function getSampleColumns () {
      return $resource(web2print.env.recipientsBaseUrlV2 + 'getSampleColumns', {
        'service': '@service'
      }, {
        'get': {
          'method': 'GET'
        }
      });
    }

    function fetchCustomers () {
      return $resource(web2print.env.epncm + 'customers', null, {
        'get': {
          'method': 'GET',
          'headers': {
            'Authorization': pnTopbar.access_token
          },
          'isArray': true
        }
      });
    }

    function getPublicUserProfile () {
      return $resource(web2print.env.usersPublicUrl, null, {
        'get': {
          'method': 'GET',
          'headers': {
            'Authorization': pnTopbar.access_token
          }
        }
      });
    }

    function getNCPUserProfile () {
      return $resource(web2print.env.ncpUsersUrl + 'getMyInfoBDB', null, {
        'get': {
          'method': 'GET',
          'headers': {
            'Authorization': pnTopbar.access_token
          }
        }
      });
    }

    function getPotentialReach (data) {
      return $resource(web2print.env.recipientsBaseUrl + 'getCountFromBisnode', null, {
        'post': {
          'method': 'POST',
          'data': data,
          'cancellable': true
        }
      });
    }

    function getEmployments () {
      return $resource(web2print.env.recipientsBaseUrl + 'bbc/employments', null, {
        'get': {
          'method': 'GET'
        }
      });
    }

    function getActivity () {
      return $resource(web2print.env.recipientsBaseUrl + 'bbc/activity', null, {
        'get': {
          'method': 'GET'
        }
      });
    }

    function getBaseMap () {
      return $resource(web2print.env.tilesBaseUrl + 'styles/postnord-basemap-web2print/style.json', null, {
        'get': {
          'method': 'GET'
        }
      });
    }

    function getIncomeRange () {
      return $resource(web2print.env.recipientsBaseUrl + 'bbc/incomeRange', null, {
        'query': {
          'method': 'GET',
          'isArray': true
        }
      });
    }

    function getEmployeeRange () {
      return $resource(web2print.env.recipientsBaseUrl + 'bbc/employeeCountRange', null, {
        'query': {
          'method': 'GET',
          'isArray': true
        }
      });
    }

    function getCountfromBBC () {
      return $resource(web2print.env.recipientsBaseUrl + 'bbc/count', {
        'zipcodes': '@zipcodes',
        'mainActivity': '@mainActivity',
        'numberOfEmployees': '@numberOfEmployees',
        'companyTurnover': '@companyTurnover',
        'employmentMainPosition': '@employmentMainPosition'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function getSearchSuggestions () {
      return $resource(web2print.env.swecoSearchBaseUrl + 'area', {
        'suggest': '@suggest',
        'limit': '@limit',
        'token': web2print.env.swecoSearchToken
      }, {
        'get': {
          'method': 'GET',
          'isArray': true
        }
      });
    }

    function getCodesFromSearch () {
      return $resource(web2print.env.swecoSearchBaseUrl + 'postalcode', {
        'type': '@type',
        'value': '@value',
        'token': web2print.env.swecoSearchToken
      }, {
        'get': {
          'method': 'GET',
          'isArray': true
        }
      });
    }

    function fetchAllBbox () {
      return $resource(web2print.env.swecoSearchBaseUrl + 'bbox', {
        'token': web2print.env.swecoSearchToken
      }, {
        post: {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
          transformRequest: transformUrlEncoded
        }
      });
    }

    function getIndividualsCountOdr () {
      return $resource(web2print.env.odrBaseUrl + 'odr/individuals/count', {
        'zipcodes': '@zipcodes',
        'formOfHousing': '@formOfHousing',
        'postalCodeGroups': '@postalCodeGroups'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function getCompanyCountOdr () {
      return $resource(web2print.env.odrBaseUrl + 'odr/company/count', {
        'zipcodes': '@zipcodes',
        'formOfHousing': '@formOfHousing',
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function fetchTerminals () {
      return $resource(web2print.env.odrBaseUrl + 'terminals', {}, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function groupPostalcodeODR () {
      return $resource(web2print.env.odrBaseUrl + 'group', {
        'postalcodes': '@postalcodes',
        'postalcodeGroup': '@postalcodeGroup'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function odrGetPostalcodes () {
      return $resource(web2print.env.odrBaseUrl + 'getPostalcodes', {
        'type': '@type',
        'value': '@value',
        'odrGroup': '@odrGroup'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function odrRemoveAndGroup () {
      return $resource(web2print.env.odrBaseUrl + 'removePostalCodes', {
        'type': '@type',
        'value': '@value',
        'odrGroup': '@odrGroup',
        'postalcodesToBeRemoved': '@postalcodesToBeRemoved'
      }, {
        'post': {
          'method': 'POST'
        }
      });
    }

    function getExceptionDates () {
      return $resource(web2print.env.pricingBaseUrl + 'exceptionDates', {}, {
        'post': {
          'method': 'POST'
        }
      });
    }


    function getDisabledDays () {
      return $resource(web2print.env.pricingBaseUrl + 'disableddays', {}, {
        'get': {
          'method': 'GET'
        }
      });
    }

    return {
      'getHolidays': getHolidays(),
      'getProducts': getProducts(),
      'getPaymentMethods': getPaymentMethods(),
      'calculatePrice': calculatePrice(),
      'fetchProductTerms': fetchProductTerms(),
      'getOrders': getOrders(),
      'getOrderById': getOrderById(),
      'cancelOrder': cancelOrder(),
      'getSampleColumns': getSampleColumns(),
      'fetchCustomers': fetchCustomers(),
      'getPublicUserProfile': getPublicUserProfile(),
      'getNCPUserProfile': getNCPUserProfile(),
      'getPotentialReach': getPotentialReach(),
      'getEmployments': getEmployments(),
      'getActivity': getActivity(),
      'getBaseMap': getBaseMap(),
      'getIncomeRange': getIncomeRange(),
      'getEmployeeRange': getEmployeeRange(),
      'getCountfromBBC': getCountfromBBC(),
      'getSearchSuggestions': getSearchSuggestions(),
      'getCodesFromSearch': getCodesFromSearch(),
      'fetchAllBbox': fetchAllBbox(),
      'getIndividualsCountOdr': getIndividualsCountOdr(),
      'getCompanyCountOdr': getCompanyCountOdr(),
      'fetchTerminals': fetchTerminals(),
      'groupPostalcodeODR': groupPostalcodeODR(),
      'odrGetPostalcodes': odrGetPostalcodes(),
      'odrRemoveAndGroup': odrRemoveAndGroup(),
      'getExceptionDates': getExceptionDates(),
      'getDisabledDays': getDisabledDays()
    };
  }

  angular.module('web2print.shared')
    .factory('apiFactory', apiFactory);
})();
